/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useHeaderStates } from '../../Providers/HeaderStates';
import { useStartupState } from '../../Providers/StartupState';
import { baseUrlImg, handleGetData } from '../../Api';
import { Loading } from '../../components/Loading';
import { Capa } from '../../components/Capa';
import * as S from './style';
import { ContactUs } from '../../components/ContactUs';

export const Starch = () => {
  const [data, setData] = useState(null);
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  const { setTitle, setBgHeader } = useHeaderStates()

  const { token, setError, loading, setLoading } = useStartupState();

  useEffect(() => {
    setError(null);
    setLoading(true);
    if (token) {
      handleGetData(token, 'api/content/copasul/fecularia/')
        .then((response) => {
          setData(response?.data?.items[0]?.data);
          if (response?.status !== 200) {
            throw new Error(response.message);
          }
        })
        .catch((e) => {
          setData(null);
          console.log(e.message);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [token]);

  // A página tem a própria capa: a faixa verde com o título, que o Header
  // desenha a partir do setTitle, fica desligada.
  useEffect(() => {
    setTitle(null);
    setBgHeader(null);
  }, [setTitle, setBgHeader]);

  if (loading) {
    return <Loading />;
  } else {
    return (
      <div style={{ position: 'relative' }}>
        <Capa
          imagem={[data?.HeroSection?.iv?.imagem?.[0], data?.imagemHeader?.iv?.[0]]}
          selo={data?.HeroSection?.iv?.titulo}
          titulo={data?.seo?.iv?.TituloSEO}
          texto={data?.HeroSection?.iv?.subTitulo}
        />

        <S.AboutPage>
          <S.AboutStarch>
            <h2>{data?.sobreFecularia?.iv.titulo}</h2>
            <p>{data?.sobreFecularia?.iv.subTitulo}</p>
          </S.AboutStarch>

          <S.Differential>
            <h2>Nossos Diferenciais</h2>

            <S.DifferentialCards>
              {
                data?.ListaCartoes?.iv.map((card) => (
                  <S.DifferentialCardsSingle key={card?.cartaoLista?.schemaId}>
                    <img src={card?.cartaoLista?.imagem ? `${baseUrlImg}${card?.cartaoLista?.imagem[0]}` : null} alt="Fecularia imagem" />

                    <h4>{card?.cartaoLista?.titulo}</h4>
                  </S.DifferentialCardsSingle>
                )
                )
              }
            </S.DifferentialCards>

          </S.Differential>
        </S.AboutPage>

        <S.Photos>
          <h2>Fotos da Fecularia</h2>

          <S.PhotoStarch>

            {data?.fotosFecularia?.iv.map((foto, index) =>
                <S.Card
                  key={index}
                  onClick={() => setSelectedPhoto(foto)}
                >
                  <img
                    src={`${baseUrlImg}${foto.cartao.imagem[0]}`}
                    alt={foto.cartao.titulo}
                    title={foto.cartao.titulo}
                  />
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
                    />
                  </svg>

                </S.Card>
              
            )}

            {selectedPhoto && (
                    <S.ModalBackdrop onClick={() => setSelectedPhoto(null)}>
                      <S.ModalContent>
                        <img src={`${baseUrlImg}${selectedPhoto.cartao.imagem[0]}`} alt="Foto ampliada" />
                        <button onClick={() => setSelectedPhoto(null)}>
                          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </button>
                      </S.ModalContent>
                    </S.ModalBackdrop>
                  )}
          </S.PhotoStarch>
        </S.Photos>

        <ContactUs />
      </div>

    );
  }
};
